import { AxiosError } from 'axios';
import { UseInfiniteQueryResult, UseQueryResult } from 'react-query';

export type QueryHelper = {
  hasQuery: boolean;
  showLoader: boolean;
  showQueryError: boolean;
  showNotFound: boolean;
  isFetching: boolean;
};

const useQueryHelper = (
  query?: UseQueryResult | UseInfiniteQueryResult,
  loading = false
): QueryHelper => {
  const hasQuery = !!query;
  let showLoader = loading;
  let isFetching = false;
  let showQueryError = false;
  let showNotFound = false;

  // @todo would be nice to use `if (hasQuery)` here instead, but ts can't figure it out :-/
  if (query) {
    const { isError, isLoading, isFetching: queryIsFetching, error } = query || {};
    showLoader = (loading || isLoading) && !isError;
    showQueryError = isError;
    showNotFound = isError && (error as AxiosError)?.status === 404;
    isFetching = queryIsFetching;
  }

  return {
    hasQuery,
    showLoader,
    showQueryError,
    showNotFound,
    isFetching,
  };
};

export default useQueryHelper;
